export default __webpack_public_path__ + "static/media/Flag_of_Taiwan.87c21dd3.svg";